<template>
  <div id="assist__main">
    <NavFooter />
    <Share v-if="isShowShare" @close="isShowShare = false" color="#443bc8" />
    <Poster :selectedRule="{ id: info.id }" v-if="isShowPoster" v-on:close="isShowPoster = false" />
    <Top
      title="助力赢课时"
      sub="帮助好友赢取 10 天欧美外教少儿英语直播课"
      desc="领取 3 集视频课"
      :noPaddingBottom="!isError && info"
    />
    <div
      v-if="
        info === undefined ||
          isAllowedAssist === undefined ||
          !$store.state.user ||
          $store.state.user === {}
      "
      class="empty"
    >
      <InlineLoading />
    </div>
    <div v-else-if="isError || info === null">
      <Error title="该活动不存在" sub="您可以自己发起助力" :showButton="false" />
      <Rule btnType="start" />
    </div>
    <div v-else-if="info">
      <User :data="info" v-on:hint="isShowShare = true" />
      <Rank
        :data="info"
        :isSelf="isSelf"
        :isAllowedAssist="isAllowedAssist"
        v-on:poster="isShowPoster = true"
        v-on:assist="assist"
      />
      <Rule v-if="isSelf" btnType="reward" />
      <Rule v-else btnType="start" />
    </div>
  </div>
</template>

<script>
import Top from "./Top"
import User from "./User"
import Rank from "./Rank"
import Poster from "../rule/Poster"
import Rule from "../rule/Rule"
import Error from "@/components/assist/Error"
import NavFooter from "@/components/public/footer"
import Share from "@/components/invite/refer/Share"
import { Toast } from "mand-mobile"

export default {
  name: "AssistMain",
  components: {
    Top,
    User,
    Rule,
    Rank,
    Poster,
    Share,
    Error,
    NavFooter,
  },
  data() {
    return {
      isError: false,
      info: undefined,
      isShowPoster: false,
      isShowShare: false,
      isAllowedAssist: undefined,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isSelf() {
      return (
        this.$route.query.user_id && this.$route.query.user_id == this.$store.state.user.user_id
      )
    },
  },
  watch: {
    user: function (val) {
      if (val && this.$route.query.user_id && this.$route.query.user_id != val.user_id) {
        this.$api.invite.BIND(this.$route.query.user_id)
      }
    },
  },
  methods: {
    async getInfo() {
      this.info = await this.$api.assist.INFO({
        ar_id: this.$route.query.ar_id,
        user_id: this.$route.query.user_id,
      })
      if (this.info) {
        this.getStatus()
        this.wxShare()
      } else {
        this.isAllowedAssist = false
      }
    },
    async getStatus() {
      this.isAllowedAssist = await this.$api.assist.STATUS(this.info.type)
    },
    async assist() {
      this.$toastLoading("正在助力...")
      const { code, msg } = await this.$api.assist.ASSIST({
        ar_id: this.$route.query.ar_id,
        user_id: this.$route.query.user_id,
      })
      if (code === "1000") {
        this.$toastSuccess("助力成功！")
        this.getInfo()
      } else {
        this.$toastError(msg)
      }
    },
    wxShare() {
      this.$wxConfig()
      const title = `点击为 ${this.info.name} 助力，赠 3 集高品质英语视频课 👉`
      const desc = "发起助力活动最高赢取 30 天欧美外教少儿英语直播课，免费晋升城市合伙人"
      const imgUrl = "https://cdn.anyteach.cn/img/assist/icon_v2.jpg"
      const link = `${window.homePageUrl}/assist?ar_id=${this.info.id}&user_id=${this.info.user_id}`

      const success = () => {
        Sentry.captureMessage(`${this.user.name} ${this.user.user_id} 分享助力排行榜 ${link}`)
        this.isShowShare = false
      }
      const cancel = () => {
        Sentry.captureMessage(`${this.user.name} ${this.user.user_id} 取消分享助力排行榜 ${link}`)
        this.isShowShare = false
      }
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title,
          desc,
          link,
          imgUrl,
          success,
          cancel,
        })
        wx.updateTimelineShareData({
          title,
          link,
          imgUrl,
          success,
          cancel,
        })
      })
    },
  },
  mounted() {
    const { query } = this.$route
    if (!query.ar_id || !query.user_id) {
      this.info = false
      this.isAllowedAssist = false
      this.isError = true
    }
    if (query.showShare) {
      Toast({
        content: "如果生成海报失败，您可以分享本页面",
        position: "bottom",
      })
      this.isShowShare = true
    }
    this.getInfo()
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.empty {
  height: 30vh;
}
#assist__main {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
</style>
